module.exports = __webpack_public_path__ + "8fd11b82f23bf2b8ca9c357482718b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-9.jpg
// module id = 1182
// module chunks = 0